import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const parseGeometryWkt = (geometryWkt: string) => {
  let coordinates: number[][] = []

  if (geometryWkt.startsWith('POLYGON')) {
    const coordsMatch = geometryWkt.match(/POLYGON \(\((.*?)\)\)/)
    if (!coordsMatch) return null

    coordinates = coordsMatch[1]
      .split(',')
      .map(coord => coord.trim().split(' ').map(Number))
  } else if (geometryWkt.startsWith('MULTILINESTRING')) {
    const coordsMatch = geometryWkt.match(/MULTILINESTRING \((.*?)\)/)
    if (!coordsMatch) return null
    coordinates = coordsMatch[1]
      .split(/\),\s*\(/)
      .map(lineString => lineString.replace(/[()]/g, ''))
      .flatMap(lineString =>
        lineString
          .split(',')
          .map(coord => coord.trim().split(' ').map(Number))
      )
  } else if (geometryWkt.startsWith('LINESTRING')) {
    const coordsMatch = geometryWkt.match(/LINESTRING \((.*?)\)/)
    if (!coordsMatch) return null
    coordinates = coordsMatch[1]
      .split(',')
      .map(coord => coord.trim().split(' ').map(Number))
  } else {
    return null
  }

  const xCoords = coordinates.map(coord => coord[0])
  const yCoords = coordinates.map(coord => coord[1])
  const x = Math.min(...xCoords)
  const y = Math.min(...yCoords)
  let width = Math.max(...xCoords) - x
  let height = Math.max(...yCoords) - y
  if (width < 1) width = 1
  if (height < 1) height = 1

  const isLineType = geometryWkt.startsWith('LINESTRING') || geometryWkt.startsWith('MULTILINESTRING')
  const finalWidth = isLineType && width === 1 ? 10 : width
  const finalHeight = isLineType && height === 1 ? 10 : height

  return { x, y, width: finalWidth, height: finalHeight }
} 